import { render, staticRenderFns } from "./FormCountryList.vue?vue&type=template&id=1edf94e3"
import script from "./FormCountryList.vue?vue&type=script&lang=ts"
export * from "./FormCountryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports